/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, ViewChild, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { DropzoneModule, DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { IcecontrolSettings, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { userTypes } from '../../login/login.config';

@Component({
  selector: 'icedragdrop',
  templateUrl: './icedragdrop.component.html',
  styleUrls: ['./icedragdrop.component.scss'],
  providers: [IcepanelComponent]
})
export class IcedragdropComponent implements OnInit {
  @Input() ctrl: IcecontrolSettings = null;
  @Input() placeholder: string = "";
  @Output() fileUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileRemove: EventEmitter<any> = new EventEmitter<any>();
  infoText: string = "";

  public config: DropzoneConfigInterface = {
    url: '',
    headers: {},
    clickable: true,
    maxFiles: 10,
    acceptedFiles: '.jpg, .png, .pdf',
    addRemoveLinks: true,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };
  public permission: IcecontrolPermission = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent) { }

  ngOnInit() {
    if (this.ctrl != null) {
      this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);

      if (this.ctrl.properties != null) {
        if (Iceutility.isdefined(this.ctrl.properties.url))
          this.config.url = this.ctrl.properties.url;

        if (Iceutility.isdefined(this.ctrl.properties.acceptedFiles))
          this.config.acceptedFiles = this.ctrl.properties.acceptedFiles;

        if (Iceutility.isdefined(this.ctrl.properties.headers))
          this.config.headers = this.ctrl.properties.headers;

        if (Iceutility.isdefined(this.ctrl.properties.infoText))
          this.infoText = this.ctrl.properties.infoText;
      }

      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.config.clickable = false;
      }
    }
  }

  public onFileUploadSuccess(event) {
    event.fileSettings = this.ctrl;

    if (this.parent && this.parent.fileUploadSuccessClick)
      this.parent.onFileUploadSuccessClick(event);
    else
      this.fileUploadSuccess.emit(event);
  }

  public onFileRemove(event) {
    event.fileSettings = this.ctrl;

    if (this.parent && this.parent.fileRemoveClick)
      this.parent.onFileRemoveClick(event);
    else
      this.fileRemove.emit(event);
  }
}
